import { UserContext } from "lib/UserContext";
import { useContext } from "react";

export default function Debugger() {
  const { user, setUser } = useContext(UserContext);
  return (
    <div className="card shadow m-5 bg-secondary text-light">
      <h6 className="card-header text-center">Debugger</h6>
      <div className="card body text-dark">
        <pre>
          {" "}
          <code>user: {JSON.stringify(user, null, 2)}</code>
        </pre>
      </div>
    </div>
  );
}
